import { schema } from "normalizr";

export const favoritePreviewSchema = new schema.Entity("favoritePreviews");

export const favoriteSchema = new schema.Entity("favorites");
